import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgIdentityVerifying(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M71.684 23.022 11.467 39.157c-2.365.634-3.765 3.077-3.127 5.456L19.448 86.07c.637 2.38 3.071 3.795 5.436 3.161l60.217-16.135c2.365-.633 3.765-3.076 3.127-5.456L77.12 26.184c-.638-2.38-3.072-3.795-5.436-3.162Z"
        fill="#F1F5F9"
      />
      <path
        d="m11.467 39.157 60.217-16.135c2.363-.633 4.799.783 5.436 3.162l1.598 5.963-68.78 18.43-1.598-5.964c-.638-2.378.763-4.822 3.127-5.456Z"
        fill="#78B441"
      />
      <path
        d="m17.233 56.903 6.473 24.19a2.668 2.668 0 0 0 3.261 1.898l20.717-5.543a2.668 2.668 0 0 0 1.877-3.273l-6.472-24.19a2.668 2.668 0 0 0-3.261-1.898L19.11 53.63a2.668 2.668 0 0 0-1.878 3.273Z"
        fill="#A6DBCB"
      />
      <path
        d="M28.072 77.359c-1.12-4.18 1.34-8.46 5.494-9.572 4.153-1.113 8.417 1.374 9.537 5.553l1.362 5.084-15.028 4.027-1.363-5.084-.002-.008ZM33.34 66.942c2.308-.618 3.674-3.002 3.052-5.324-.623-2.323-2.998-3.704-5.306-3.086-2.308.619-3.674 3.003-3.052 5.325.622 2.322 2.998 3.704 5.306 3.085Z"
        fill="#007A5F"
      />
      <path
        d="M18.133 84.252 9.128 50.645a.8.8 0 1 1 1.545-.414l9.005 33.607c.824 3.076 3.965 4.897 7.01 4.081l49.908-13.373a.8.8 0 0 1 .414 1.546L27.103 89.466c-3.908 1.047-7.92-1.293-8.97-5.213Z"
        fill="#0F172A"
      />
      <path
        d="M74.283 40.736a.8.8 0 0 1 .414 1.545l-26.358 7.063a.8.8 0 1 1-.414-1.545l26.358-7.063Z"
        fill="#78B441"
      />
      <path
        d="M70.749 67.83a.8.8 0 0 1 .414 1.544L54.875 73.74a.8.8 0 1 1-.414-1.546L70.75 67.83ZM79.462 60.064a.8.8 0 0 1 .414 1.545l-26.358 7.063a.8.8 0 1 1-.414-1.545l26.358-7.063ZM78.106 55.006a.8.8 0 0 1 .415 1.545l-26.359 7.063a.8.8 0 1 1-.414-1.545l26.358-7.063ZM75.64 45.803a.8.8 0 0 1 .415 1.545L49.696 54.41a.8.8 0 1 1-.414-1.546l26.359-7.062Z"
        fill="#B3C0D0"
      />
      <path
        d="m88.917 71.564 21.434 17.664a4.637 4.637 0 0 1 .479 6.722 4.765 4.765 0 0 1-6.814.205l-19.937-19.3 4.838-5.291Z"
        fill="#007A5F"
      />
      <path d="m95.72 77.097.639 11.523-12.28-11.782 4.866-5.274 6.775 5.533Z" fill="#00664F" />
      <path
        d="m95.72 77.097.639 11.523-12.28-11.783 4.866-5.273 6.774 5.533Zm-10.241-.303 9.74 9.346-.474-8.548-5.705-4.659-3.561 3.861Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.056 82.386c9.557 4.893 21.27 1.112 26.163-8.444 4.893-9.556 1.112-21.27-8.445-26.163-9.556-4.893-21.27-1.112-26.162 8.445-4.893 9.556-1.113 21.27 8.444 26.162Z"
        fill="#78B441"
      />
      <path
        d="M90.9 65.083c0 7.724-6.26 13.986-13.985 13.986-7.724 0-13.986-6.262-13.986-13.986 0-7.724 6.262-13.986 13.986-13.986 7.724 0 13.986 6.262 13.986 13.986Z"
        fill="#E6F4F0"
      />
      <path
        d="M64.859 64.742c0-6.47 5.245-11.716 11.715-11.716a.8.8 0 1 1 0 1.6c-5.587 0-10.116 4.53-10.116 10.116a.8.8 0 0 1-1.6 0Z"
        fill="#fff"
      />
      <path
        d="M62.13 65.083c0-8.147 6.448-14.786 14.444-14.786a.8.8 0 1 1 0 1.6c-7.076 0-12.845 5.885-12.845 13.186s5.77 13.186 12.845 13.186a.8.8 0 1 1 0 1.6c-7.996 0-14.444-6.639-14.445-14.786ZM100.607 42.99a.8.8 0 0 1 1.054 1.205l-5.458 4.775a.8.8 0 0 1-1.053-1.204l5.457-4.776ZM101.564 51.02a.8.8 0 0 1 .506 1.518l-4.094 1.364a.8.8 0 1 1-.506-1.517l4.094-1.365ZM91.523 41.249a.8.8 0 1 1 1.485.593l-1.364 3.412a.8.8 0 0 1-1.486-.594l1.365-3.411Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgIdentityVerifying)
